/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstCalendarCenterSupplierUpdateBase
 */
export interface MstCalendarCenterSupplierUpdateBase {
    /**
     * 
     * @type {boolean}
     * @memberof MstCalendarCenterSupplierUpdateBase
     */
    deleteFlg?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCalendarCenterSupplierUpdateBase
     */
    insertDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendarCenterSupplierUpdateBase
     */
    insertUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCalendarCenterSupplierUpdateBase
     */
    updateDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendarCenterSupplierUpdateBase
     */
    updateUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCalendarCenterSupplierUpdateBase
     */
    deleteDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendarCenterSupplierUpdateBase
     */
    deleteUser?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCalendarCenterSupplierUpdateBase
     */
    companyId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendarCenterSupplierUpdateBase
     */
    orgCenterId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendarCenterSupplierUpdateBase
     */
    orgSupplierId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCalendarCenterSupplierUpdateBase
     */
    calendarDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCalendarCenterSupplierUpdateBase
     */
    enableSupplierShipday?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCalendarCenterSupplierUpdateBase
     */
    enableOrderday?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MstCalendarCenterSupplierUpdateBase
     */
    arrivalRatio?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendarCenterSupplierUpdateBase
     */
    remarks?: string | null;
}

/**
 * Check if a given object implements the MstCalendarCenterSupplierUpdateBase interface.
 */
export function instanceOfMstCalendarCenterSupplierUpdateBase(value: object): value is MstCalendarCenterSupplierUpdateBase {
    return true;
}

export function MstCalendarCenterSupplierUpdateBaseFromJSON(json: any): MstCalendarCenterSupplierUpdateBase {
    return MstCalendarCenterSupplierUpdateBaseFromJSONTyped(json, false);
}

export function MstCalendarCenterSupplierUpdateBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCalendarCenterSupplierUpdateBase {
    if (json == null) {
        return json;
    }
    return {
        
        'deleteFlg': json['delete_flg'] == null ? undefined : json['delete_flg'],
        'insertDatetime': json['insert_datetime'] == null ? undefined : (new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'] == null ? undefined : json['insert_user'],
        'updateDatetime': json['update_datetime'] == null ? undefined : (new Date(json['update_datetime'])),
        'updateUser': json['update_user'] == null ? undefined : json['update_user'],
        'deleteDatetime': json['delete_datetime'] == null ? undefined : (new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'] == null ? undefined : json['delete_user'],
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'orgCenterId': json['org_center_id'] == null ? undefined : json['org_center_id'],
        'orgSupplierId': json['org_supplier_id'] == null ? undefined : json['org_supplier_id'],
        'calendarDate': json['calendar_date'] == null ? undefined : (new Date(json['calendar_date'])),
        'enableSupplierShipday': json['enable_supplier_shipday'] == null ? undefined : json['enable_supplier_shipday'],
        'enableOrderday': json['enable_orderday'] == null ? undefined : json['enable_orderday'],
        'arrivalRatio': json['arrival_ratio'] == null ? undefined : json['arrival_ratio'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
    };
}

export function MstCalendarCenterSupplierUpdateBaseToJSON(json: any): MstCalendarCenterSupplierUpdateBase {
    return MstCalendarCenterSupplierUpdateBaseToJSONTyped(json, false);
}

export function MstCalendarCenterSupplierUpdateBaseToJSONTyped(value?: MstCalendarCenterSupplierUpdateBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'company_id': value['companyId'],
        'org_center_id': value['orgCenterId'],
        'org_supplier_id': value['orgSupplierId'],
        'calendar_date': value['calendarDate'] == null ? value['calendarDate'] : value['calendarDate'].toISOString(),
        'enable_supplier_shipday': value['enableSupplierShipday'],
        'enable_orderday': value['enableOrderday'],
        'arrival_ratio': value['arrivalRatio'],
        'remarks': value['remarks'],
    };
}

